import { render, staticRenderFns } from "./CorrectErrorDetails.vue?vue&type=template&id=5685c009&scoped=true&"
import script from "./CorrectErrorDetails.vue?vue&type=script&lang=js&"
export * from "./CorrectErrorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685c009",
  null
  
)

export default component.exports